import {
  Directive,
  inject,
  TemplateRef,
  ViewContainerRef
} from "@angular/core";

@Directive({
  selector: "[sntTemplate]",
  standalone: false
})
export class TemplateDirective {
  templateRef = inject(TemplateRef);
  viewContainerRef = inject(ViewContainerRef);
}
